// @flow

import type { PropsSchema, BasicProps, EasyAction } from '../../type'

import * as React from 'react'
import css from './IScroll.scss'
import computeData from '../hoc/computeData'
import IScroll from 'iscroll/build/iscroll-probe'
import Spinner from 'frame/ui/Spinner'

type Props = BasicProps & {
  children: React.ChildrenArray<React.Node>,
  scrollId: ?string,
  isResetState: boolean,
  noScrollbars: boolean,
  noLoading: boolean,
  showPullDown: boolean,
  isRelative?: boolean,
  pullUpTheData: string,
  pullDownTheData: string,
  pullUpLoading: string,
  pullUpLoadFail: string,
  pullUpNoData: string
};

@computeData()
export default class Folder extends React.PureComponent<Props, any> {
  state = {
    pullUpState: -1,
    height: 0,
    iScrollId: null
  };

  static defaultProps = {
    isResetState: true
  };

  myScroll: any;
  scrollEndEventDoing: number;

  static schema: PropsSchema = [
    {
      type: 'text',
      key: 'scrollId',
      title: 'Id'
    },
    {
      type: 'boolean',
      key: 'isResetState',
      title: 'Id改变时清空iScroll状态',
      defaultValue: true
    },
    {
      type: 'boolean',
      key: 'showPullDown',
      title: '显示下拉刷新'
    },
    {
      type: 'boolean',
      key: 'noScrollbars',
      title: '不显示滚动条'
    },
    {
      type: 'boolean',
      key: 'noLoading',
      title: '不显示loading'
    },
    {
      type: 'boolean',
      key: 'isRelative',
      title: '相对定位'
    },
    {
      type: 'event',
      title: '上拉完成事件',
      event: 'pullUp'
    },
    {
      type: 'event',
      title: '下拉完成事件',
      event: 'pullDown',
      visible: props => props.showPullDown
    },
    'separator',
    {
      type: 'text',
      key: 'pullUpTheData',
      title: '上拉加载数据（文案）'
    },
    {
      type: 'text',
      key: 'pullDownTheData',
      title: '下拉加载数据（文案）',
      visible: props => props.showPullDown
    },
    {
      type: 'text',
      key: 'pullUpLoading',
      title: '正在加载（文案）'
    },
    {
      type: 'text',
      key: 'pullUpLoadFail',
      title: '加载失败（文案）'
    },
    {
      type: 'text',
      key: 'pullUpNoData',
      title: '没有更多数据了（文案）'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '上拉加载完成',
      name: 'pullUpSuccess'
    },
    {
      title: '下拉加载完成',
      name: 'pullDownSuccess',
      visible: props => props.showPullDown
    },
    {
      title: '刷新iscroll',
      name: 'refshIScroll'
    },
    {
      title: '加载失败',
      name: 'reject'
    },
    {
      title: '没有更多数据',
      name: 'nullData'
    },
    {
      title: '滚动到',
      name: 'scrollTo',
      dataSchema: [
        {
          key: 'scrollTop',
          title: '距离顶部的距离',
          required: true
        }
      ]
    }
  ];

  actionPullUpSuccess = () => {
    const { height, pullUpState } = this.state
    if (pullUpState !== -1 && pullUpState !== 2) return
    if (this.refs.iscrollDiv.children[0].scrollHeight >= height) {
      this.setIscrollState({ pullUpState: 0 })
    }
    this.myScroll && this.myScroll.refresh()
  };

  actionPullDownSuccess = () => {
    const { showPullDown } = this.props
    if (!showPullDown) return
    const { pullUpState } = this.state
    if (pullUpState !== 22) return
    this.setIscrollState({ pullUpState: 0 })
    this.myScroll && this.myScroll.refresh()
  };

  actionReject = () => {
    let { pullUpState } = this.state || {}
    if (pullUpState === 2) {
      this.setIscrollState({ pullUpState: 3 })
    } else if (pullUpState === 22) {
      this.setIscrollState({ pullUpState: 1 })
    }
  };

  actionNullData = () => {
    this.setIscrollState({ pullUpState: 4 })
  };

  actionRefshIScroll = () => {
    setTimeout(() => {
      this.myScroll && this.myScroll.refresh()
    }, 200)
  };

  actionScrollTo = (data: { scrollTop: string }, dynamicData: any) => {
    setTimeout(() => {
      const { scrollTop } = data
      const y = this.props.jsEnv.getStringWithAdditionCtx(
        scrollTop,
        dynamicData
      )
      this.myScroll && this.myScroll.scrollTo(0, -parseFloat(y), 500)
    }, 0)
  };

  setIscrollState = (stateObj: { [string]: any }, state: ?any) => {
    state = state || this.state
    let { iScrollId } = state
    if (iScrollId) {
      stateObj = { [iScrollId]: { ...state[iScrollId], ...stateObj } }
    }
    this.setState(stateObj)
  };

  componentDidMount () {
    let { callActions, jsEnv, scrollId, noScrollbars, isRelative } = this.props
    if (scrollId) {
      this.setState({ iScrollId: jsEnv.getString(scrollId) })
    }
    let rootElement = window.document.getElementById('rootEasyComp_comp')
    if (isRelative) {
      rootElement = this.refs.iscrollDiv
    }
    const rootParent = rootElement.parentNode
    if (isRelative) {
      rootElement = rootParent
    }
    setTimeout(() => {
      const screenHeight =
        rootParent.scrollHeight -
        parseInt(rootParent.style.paddingTop || 0, 10) -
        parseInt(rootParent.style.paddingBottom || 0, 10)
      const contentHeight = rootElement.children[0].clientHeight || 0
      const height = screenHeight - contentHeight
      if (this.refs.iscrollDiv) {
        this.setState({
          height
        })
        const _this = this
        const myScroll = (this.myScroll = new IScroll(this.refs.iscrollDiv, {
          scrollbars: !noScrollbars,
          mouseWheel: true,
          preventDefault: false,
          probeType: 2
        }))
        _this.scrollEndEventDoing = 0
        myScroll.on('scrollEnd', function () {
          let { showPullDown } = _this.props
          let { pullUpState, iScrollId } = _this.state || {}
          if (iScrollId && _this.state[iScrollId]) {
            pullUpState = _this.state[iScrollId].pullUpState || -1
          }
          if (pullUpState === 1) {
            _this.setIscrollState({ pullUpState: 2 })
            callActions('pullUp')
          }
          if (showPullDown && pullUpState === 21) {
            _this.setIscrollState({ pullUpState: 22 })
            callActions('pullDown')
          }
        })
        myScroll.on('scroll', function () {
          let { showPullDown } = _this.props
          if (showPullDown && this.y > 40) {
            if (!_this.scrollEndEventDoing) {
              _this.setIscrollState({ pullUpState: 21 })
            }
            _this.setScroolEndWait()
          }
          if (Math.abs(this.y) - Math.abs(this.maxScrollY) > 40) {
            if (!_this.scrollEndEventDoing) {
              _this.setIscrollState({ pullUpState: 1 })
            }
            _this.setScroolEndWait()
          }
        })
        this.refs.iscrollDiv.addEventListener(
          'touchmove',
          function (e) {
            e.preventDefault()
          },
          false
        )
      }
    }, 100)
  }

  setScroolEndWait () {
    if (this.scrollEndEventDoing) {
      clearTimeout(this.scrollEndEventDoing)
    }
    let _this = this
    this.scrollEndEventDoing = setTimeout(function () {
      _this.scrollEndEventDoing = 0
    }, 1000)
  }

  componentWillUpdate (nextProps: Props, nextState: any) {
    const { scrollId, jsEnv, isResetState } = nextProps
    if (scrollId && this.props.jsEnv !== nextProps.jsEnv) {
      this.setState({ iScrollId: jsEnv.getString(scrollId) })
    }
    if (nextState.iScrollId !== this.state.iScrollId) {
      if (isResetState) {
        this.setIscrollState({ pullUpState: -1 }, nextState)
      }
      if (this.myScroll) {
        this.myScroll.scrollTo(0, 0)
        this.actionRefshIScroll()
      }
    }
  }

  render () {
    if (!this.props.visible) {
      return null
    }
    let { id, children } = this.props
    let { pullUpState, height = 0, iScrollId } = this.state || {}
    if (iScrollId && this.state[iScrollId]) {
      pullUpState = this.state[iScrollId].pullUpState
    }
    return (
      <div ref='iscrollDiv' className={css.main} style={{ height }} id={id}>
        <div>
          {this.renderPullDown(pullUpState)}
          {children}
          {this.renderPull(pullUpState)}
        </div>
      </div>
    )
  }

  renderPullDown = (pullState: number) => {
    let {
      pullUpLoading,
      noLoading,
      showPullDown,
      pullDownTheData
    } = this.props
    if (!showPullDown) return null
    return (
      <div key='2' className={css.pulldown}>
        {pullState === 0 && <div>{pullDownTheData || '下拉刷新'}</div>}
        {pullState === 21 && <div>松开加载</div>}
        {pullState > 21 && (
          <div>
            {pullState === 22 && (
              <Spinner
                show
                loading={!noLoading}
                padding={0}
                text={pullUpLoading || '正在加载'}
              />
            )}
          </div>
        )}
      </div>
    )
  };

  renderPull = (pullState: number) => {
    let {
      jsEnv,
      pullUpTheData,
      pullUpLoading,
      pullUpLoadFail,
      pullUpNoData,
      noLoading
    } = this.props
    pullUpNoData = jsEnv.getString(pullUpNoData)
    return (
      <div
        key='1'
        className={`${css.pull} ${pullState === 4 ? css.pullnone : ''}`}
      >
        <div>
          {pullState === 0 && (pullUpTheData || '上拉加载数据')}
          {pullState === 1 && '松开加载'}
          {pullState > 1 && (
            <div>
              {pullState === 2 && (
                <Spinner
                  show
                  loading={!noLoading}
                  padding={0}
                  text={pullUpLoading || '正在加载'}
                />
              )}
              {pullState === 3 && (pullUpLoadFail || '加载失败')}
              {pullState === 4 && (pullUpNoData || '没有更多数据了')}
            </div>
          )}
        </div>
      </div>
    )
  };
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/IScroll.js